var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-unknown"},[_c('MessageText',{attrs:{"message":{
        content: _vm.$translate('MTYPE_UNKNOWN'),
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }